export default function CourseTerms() {
    return (
        <>
            <section id="guitar-course-details-section">
                <div className="guitar-course-details-container">
                    <div className="guitar-course-details-content">
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">TRAINING INVOLVES</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Keyboard technique, finger strengthening, scales, and arpeggios.</li>
                                <li>Sight-reading, ear training, and harmony.</li>
                                <li>Classical piano repertoire (Western & Indian).</li>
                                <li>Contemporary and accompaniment styles (jazz, pop, film).</li>
                                <li>Improvisation, composition, and performance practice.</li>
                            </ul>
                        </div>
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Who is it For</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Children exploring music for the first time.</li>
                                <li>Adult learners beginning as a hobby.</li>
                                <li>Intermediate/advanced learners preparing for stage and exams.</li>
                                <li>Composers, arrangers, and accompanists.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Learning Outcomes</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Fluent piano playing with precision and expression.</li>
                                <li>Musical interpretation & improvisation.</li>
                                <li>Ability to compose and accompany singers/instrumentalists.</li>
                                <li>Preparedness for Trinity, ABRSM, and Rock School certifications.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 